class ResponseErrorMessages {
  get(errorCode) {
    errorCode = errorCode ? errorCode : 0;
    // console.log('DEBUG running response errorCode', errorCode);
    switch (errorCode.toString()) {
      case '1':
        return 'The application has encountered an unknown error.';
      case '2':
        return 'This player is already registered.';
      case '3':
        return 'Invalid phone number.';
      case '4':
        return 'Invalid email address.';
      case '5':
        return 'The minimum age requirement is not met.';
      case '6':
        return 'The cnp is not valid.';
      case '7':
        return 'Email is already registered';
      case '8':
        return 'Phone number is already registered.';
      case '9':
        return 'The application has encountered a saving error.';
      case '10':
        return 'Inserted code is invalid.';
      case '11':
        return 'Current password is invalid.';
      case '12':
        return 'Authentication expired! Please login and try again.';
      case '13':
        return 'Invalid token.';
      case '14':
        return 'Phone number SMS limit was reached.';
      case '15':
        return 'Insufficient funds.';
      case '16':
        return 'Invalid request.';
      case '17':
        return 'Duplicate request.';
      case '18':
        return 'Negative amount.';
      case '19':
        return 'Cannot withdraw while having active bonuses.';
      case '20':
        return 'This email address is not registered';
      case '21':
        return 'This account is suspended. Please contact support.';
      case '22':
        return 'This account is closed. Please contact support.';
      case '23':
        return 'This account is self excluded.';
      case '43':
        return 'Invalid SMS code';
      default:
        return 'The application has encountered an unknown error.';
    }
  }

  getParsedRegisterError(errorCode) {
    if (!errorCode) return 'The application has encountered an unknown error.';
    switch (errorCode.toString()) {
      case '1':
        return {
          code: '1',
          msg: 'The application has encountered an unknown error.',
          type: 'global',
        };
      case '4':
        return {
          code: '4',
          msg: 'Invalid email address.',
          type: 'email',
        };
      case '5':
        return {
          code: '5',
          msg: 'The minimum age requirement is not met.',
          type: 'global',
        };
      case '6':
        return {
          code: '6',
          msg: 'The NIN is not valid.',
          type: 'nin',
        };
      case '8':
        return {
          code: '8',
          msg: 'Phone number is already registered.',
          type: 'phone',
        };
      case '9':
        return {
          code: '9',
          msg: 'The application has encountered a saving error.',
          type: 'global',
        };
      case '10':
        return {
          code: '10',
          msg: 'Inserted code is invalid.',
          type: 'otp',
        };
      case '11':
        return {
          code: '11',
          msg: 'Current password is invalid',
          type: 'password',
        };
      case '12':
        return {
          code: '12',
          msg: 'Authentication expired! Please login and try again.',
          type: 'global',
        };
      case '13':
        return {
          code: '13',
          msg: 'Invalid token.',
          type: 'global',
        };
      case '14':
        return {
          code: '14',
          msg: 'Phone number SMS limit was reached.',
          type: 'otp',
        };
      case '16':
        return {
          code: '16',
          msg: 'Invalid request.',
          type: 'global',
        };
      case '17':
        return {
          code: '17',
          msg: 'Duplicate request.',
          type: 'global',
        };
      case '43':
        return {
          code: '43',
          msg: 'Invalid SMS code',
          type: 'global',
        };

      case '2':
        return {
          code: '2',
          msg: 'This player is already registered.',
          type: 'global',
        };
      case '3':
        return {
          code: '3',
          msg: 'Invalid phone number.',
          type: 'phone',
        };
      case '7':
        return {
          code: '7',
          msg: 'Email is already registered',
          type: 'email',
        };
      case '26':
        return {
          code: '26',
          msg: 'IP not allowed',
          type: 'global',
        };
      case '62':
        return {
          code: '62',
          msg: 'Invalid country code',
          type: 'global',
        };
      case '63':
        return {
          code: '63',
          msg: 'Empty value',
          type: 'global',
        };
      case '64':
        return {
          code: '64',
          msg: 'Partial account not found',
          type: 'global',
        };
      case '65':
        return {
          code: '65',
          msg: 'Partial account has another info',
          type: 'global',
        };
      case '59':
        return {
          code: '59',
          msg: 'Password too short',
          type: 'password',
        };
      default:
        return {
          code: '1',
          msg: 'The application has encountered an unknown error.',
          type: 'global',
        };
    }
  }
}

export default new ResponseErrorMessages();
